export default "__VITE_ASSET__2d9de203__"